import { render, staticRenderFns } from "./AccountDeletionMessage.vue?vue&type=template&id=8f6b8d48&scoped=true&"
import script from "./AccountDeletionMessage.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b8d48",
  null
  
)

export default component.exports